import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Journey() {
  return (
    <section className="journey-con position-relative">

      {/* <figure className="journey-rightimage mb-0">
        <img
          src="/assets/images/special-rightimage.png"
          alt="image"
          className="img-fluid"
        />
      </figure> */}

      <div className="container">
        <div className="row">

          {/* IMAGE ANIMATION */}
          <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12">
            <motion.div
              className="journey_wrapper position-relative"
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.4 }}
            >
              <figure className="journey-image mb-0">
                <img
                  src="/assets/website-images/festivo_about_img.jpg"
                  alt="image"
                  className="img-fluid"
                />
              </figure>
            </motion.div>
          </div>

          {/* CONTENT ANIMATION */}
          <div className="col-xl-7 col-lg-6 col-md-12 col-sm-12 col-12">
            <motion.div
              className="journey_content"
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
              viewport={{ once: true, amount: 0.4 }}
            >

              <h2>
                A <span>Legacy</span> of Crafting DeSSertS
              </h2>

              <p className="text1">
                At Festivo, our story is a blend of long-standing tradition and rigorous academic precision. While the Festivo brand represents the pinnacle of Italian craft, our family has been immersed in the art of crafting rich ice creams since 1984.
              </p>

              <h4>The Passion Behind the Scoop</h4>

              <p className="text2">
                Our gelato isn't just a product; it is a labor of love led by a uniquely qualified artisan. Our lead chef is a trained Engineer (University of Michigan), a Lawyer (Columbia University), and holds a Doctorate (Victoria University). Driven by pure passion rather than a paycheck, they transitioned from the world of academia and law to the kitchen.
              </p>

              <p className="text1">
                To ensure technical perfection, our chef completed Advanced Level training at the Italian Gelato University, mastering the delicate balance of temperature, texture, and density that defines world-class gelato.
              </p>

              

            </motion.div>
          </div>

        </div>
      </div>

    </section>
  );
}

export default Journey;